module.exports = __webpack_public_path__ + "static/media/expandIcon.271332f9.svg";